export default {"src":"/_next/static/media/freeShipping.571114f2.svg","height":13,"width":12};